import { Box, Typography } from '@mui/material';
import eventBus from 'containers/SaasModern/Mit/EventMit';
import { useEffect, useMemo, useState } from 'react';
import SelectCategory from './SelectCategory';
import CardCategory from './CardCategoty';
import Container from 'common/components/Container';
import HeroSearch from './HeroSearch';
import TableCategory from './TableCategory';

const CategorySection = ({ bots, slice, is_pricing_ai }) => {
  const [searchs, setSearch] = useState('');
  const [botsSelected, setBotsSelected] = useState(bots?.[0]?.bots || null);
  const handleChange = (newValue) => {
    setBotsSelected(newValue);
  };

  useEffect(() => {
    const handler = (data) => {
      setSearch(data.itemSearch);
    };

    eventBus.on('customEvent', handler);
    return () => {
      eventBus.off('customEvent', handler);
    };
  }, []);

  const filterBots = (search, bots) => {
    if (!search) return bots;

    return bots.filter((bot) =>
      bot.name.toLowerCase().includes(search.toLowerCase()),
    );
  };
  const filteredBots = searchs
    ? filterBots(
        searchs,
        bots.flatMap((b) => b.bots),
      )
    : botsSelected;
  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '50px',
          mt: '24px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <HeroSearch />
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
          }}
        >
          <Typography
            sx={{
              color: '#111927',
              fontSize: ['14px', '16px', '20px'],
              fontWeight: '700',
            }}
          >
            {slice ? slice.primary.title : 'category'}
            
          </Typography>
          <Box
            sx={{
              width: '100 %',
              display: 'flex',
              flexDirection: 'column',
              gap: '56px',
            }}
          >
            <SelectCategory
              bots={bots}
              datas={botsSelected}
              handleChange={handleChange}
            />
            {is_pricing_ai ? (
              <TableCategory data={filteredBots} />
            ) : (
              <CardCategory data={filteredBots} />
            )}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default CategorySection;
